import { type ErrorInfo, type PropsWithChildren, PureComponent, type ReactNode } from 'react'

import { dataLayerPublish } from '@dhl/datalayer'

type State = {
  hasError: boolean
}

export class InteractionErrorBoundary extends PureComponent<PropsWithChildren, State> {
  constructor(props: PropsWithChildren) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    dataLayerPublish('ERROR', { id: 'interaction', error, errorInfo })
  }

  render(): ReactNode {
    const { children } = this.props
    const { hasError } = this.state

    // An interaction is supplementary to the page it covers, so a crash in one must not take that page down too.
    return hasError ? null : children
  }
}
